import { proxy } from 'valtio'
import { CommonApi, CountryDetail, Option } from '../../generated'
import { apiConfig } from '../apiConfig'
import { isJa } from '../i18n/useLang'
import { getName } from '../util/getName'

export const countriesStore = proxy<{ items: Option[], detailMap: Map<number, CountryDetail> }>({
  items: [],
  detailMap: new Map(),
})

const api = new CommonApi(apiConfig)
export async function loadCountries() {
  await api.getCountries().then((result) => {
    countriesStore.items = result
  })
  await api.getCountryDetails().then((result) => {
    const map = new Map<number, CountryDetail>()
    result.forEach((d) => {
      map.set(d.id, d)
    })
    countriesStore.detailMap = map
  })
}

export function getCountryName(id?: number, defaultValue?: string, isOther?: boolean) {
  if (id === undefined) return '' // todo 見直す
  return getName(countriesStore.items, id, defaultValue, isOther)
}

export function getCountryDetail(id?: number) {
  if (id === undefined || id === null) return undefined
  return countriesStore.detailMap.get(id)
}

export function getCountryOptions(countries: {
  items: Option[]
}): Array<Option & { label: string; value: string }> {
  const key = isJa() ? 'nameJa' : 'name'
  const result = countries.items.map((c) => ({
    ...c,
    value: c.code,
    label: c[key],
  }))
  result.sort((a, b) => {
    if (a.isOther) return 1
    if (b.isOther) return -1
    if (a.label < b.label) {
      return -1
    } else if (a.label === b.label) {
      return 0
    } else {
      return 1
    }
  })
  return result
}
